export default {
  navigationBarTitleText: '在线客服-文字版',
};
